import Select from "~/components/mantine/select/Select";
import Modal from "~/components/ui/modal/Modal";

import { formatIdentityName } from "../utils/formatIdentityName";
import { IdentitySelectionModalProps } from "./types";

const IdentitySelectionModal = ({
  isOpen,
  onClose,
  identities,
  onIdentityChosen,
}: IdentitySelectionModalProps) => {
  const identityOptions = identities.map((identity) => ({
    value: identity.id.toString(),
    label: formatIdentityName(identity, "full"),
  }));

  const handleIdentityChange = (value: string | null) => {
    if (value) {
      const identity = identities.find((id) => id.id.toString() === value);
      if (identity) {
        onIdentityChosen(identity);
      }
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      closeModal={onClose}
      modalLabel={<h3>Select Identity</h3>}
      width="32rem"
    >
      <div style={{ padding: "var(--lg) 0" }}>
        <p>
          Please select Google Analytics account you want this integration to
          pull data from:
        </p>
        <div style={{ marginTop: "var(--md)" }}>
          <Select
            data={identityOptions}
            onChange={handleIdentityChange}
            placeholder="Select an identity"
            searchable={false}
          />
        </div>
      </div>
    </Modal>
  );
};

export default IdentitySelectionModal;
